import React from 'react';

export interface SpinnerProps {
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = (props) => {
  return (
    <div className={'styled-spinner' + (props.className ? ' ' + props.className : '')} />
  );
};
